
import './EmailConfirmation.scss'
import { useAuthCheck } from '../../hooks/Authentication';
import { useCountdown } from '../../hooks/customHooks';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { verifyEmail, setEmailVerified, setEmailNotVerified } from '../../redux/actions/userManagementActions';
import { WebPortalState } from '../../redux/store';
import { TPPMessageCode } from '../../redux/reduxTypes';
import { useHistory } from 'react-router';

export enum EmailEnvironment {
    Sandbox = 1,
    Production = 2,
    User = 3,
}
export default function EmailConfirmation() {
    useAuthCheck()
    const redirect = () => {
        if (authenticated) {
            history.push('/user')
        } else {
            history.push('/signin')
        }
    }

    const path = globalThis.location;
    const url = new URL(path.href);
    const params = new URLSearchParams(url.search);

    const ticket = params.get('ticket') ?? 'none';
    const environment = Number.parseInt(params.get('e') ?? '3')
    const { countdown: timer, startTime } = useCountdown(5, redirect, false)

    const verifyStatus = useSelector((state: WebPortalState) => state.verifyState)
    const authenticated = useSelector((state: WebPortalState) => state.tokenAssistant.loggedIn)

    const dispatch = useDispatch();

    const [loading, setLoading] = useState(true);
    const [invalidVerify, setInvalidVerify] = useState(false)

    const history = useHistory()

    useEffect(() => {
        if (params && ticket) {
            if (ticket === 'none') {
                setInvalidVerify(true)
                setLoading(false)
            } else {
                dispatch(verifyEmail(ticket, environment))
            }
        }
    }, [])

    useEffect(() => {
        if (verifyStatus.data) {
            const res = verifyStatus.data
            const status: TPPMessageCode = Number.parseInt(res.attributes.status as any)
            if (status === TPPMessageCode.FAILED) {
                dispatch(setEmailNotVerified())
                setInvalidVerify(true)
                setLoading(false);
                startTime();
            } else {
                dispatch(setEmailVerified())
                setLoading(false);
                startTime();
            }
        } else if (verifyStatus.error) {
            dispatch(setEmailNotVerified())
            setInvalidVerify(true);
        }
    }, [verifyStatus])



    return (
        <div className="email-content">
            {loading ? (
                ''
            ) : invalidVerify ? (
                <div className="email-heading">
                    <svg width="140" height="140" viewBox="0 0 140 140" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g opacity="0.05">
                            <rect width="140" height="140" rx="70" fill="#CF013B" />
                        </g>
                        <rect x="30" y="30" width="80" height="80" rx="40" fill="#CF013B" />
                        <path d="M79.3332 60.6667L60.6665 79.3334" stroke="white" strokeWidth="4" strokeMiterlimit="10" strokeLinecap="round" />
                        <path d="M79.3332 79.3334L60.6665 60.6667" stroke="white" strokeWidth="4" strokeMiterlimit="10" strokeLinecap="round" />
                    </svg>
                    <h1 style={{ "marginBottom": "14px" }}>Invalid Request!</h1>
                    <p>The ticket provided is invalid</p>
                    <p>You will be redirected in {timer} seconds...</p>
                    <br />
                </div>
            ) : (
                <div className="email-heading">
                    <svg width="140" height="140" viewBox="0 0 140 140" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect opacity="0.05" width="140" height="140" rx="70" fill="#4CB578" />
                        <rect x="30" y="30" width="80" height="80" rx="40" fill="#4CB578" />
                        <path d="M56 72L64 80L84 60" stroke="white" strokeWidth="4" strokeMiterlimit="10" strokeLinecap="round" />
                    </svg>
                    <h1 style={{ "marginBottom": "14px" }}>Email confirmed!</h1>
                    <p>You will be redirected in {timer} seconds...</p>
                    <br />
                </div>

            )}
        </div>
    )
}